import '../styles/Home.css';
import '../styles/Share.css';

import mhdle from '../assets/logo-monster-hunter-dle.webp';
import nonogramdle from '../assets/logo-nonogramdle.png';
import { useTranslation } from 'react-i18next';

function Socials() {
    const { t } = useTranslation();

	return (
		<div className="share">
			<div className='share-container'>
				<h3>{t('share.moreFun')}</h3>
				<div className='share-item'>
					<a href='https://monster-hunter-dle.akato.fr/' target='_blank' rel='noreferrer'>
						<img src={mhdle} alt="mhdle" title='Monster Hunter DLE'/>
						<span>{t('share.monsterHunter')}</span>
					</a>
					<a href='https://nonogramdle.lps-consulting.fr/' target='_blank' rel='noreferrer'>
						<img src={nonogramdle} alt="nonogramdle" title='Nonogram DLE'/>
						<span>{t('share.nonogramDLE')}</span>
					</a>
				</div>
			</div>

		</div>
	);
}

export default Socials;
